const fontawesomeAliases = {
	person: 'fa-solid fa-user',
	lock: 'fa-solid fa-lock',
	visibility: 'fa-solid fa-eye',
	visibility_off: 'fa-solid fa-eye-slash',
	sign_in: 'fa-regular fa-sign-in',
	key: 'fa-regular fa-key',
	dashboard: 'md:dashboard',
	person_function: 'fa-solid fa-user-group',
	event: 'md:event',
	close: 'md:close',
	clear: 'md:clear',
	add: 'md:add',
	// delete: 'fa-solid fa-trash',
}

export { fontawesomeAliases }
